import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { FaqModel } from "@tCentro/Services/CENBrandFAQService";

import FaqState from "@tCentro/Store/Components/Faq/FaqState";

const initialState: FaqState = {
    faqs: [],
    isLoading: false,
};

export default createTypedReducerWithImmer(initialState, {
    "Custom/FaqData/BeginLoad": (draft: FaqState) => {
        draft.isLoading = true;
    },
    "Custom/Faq/CompletedLoad": (
        draft: FaqState,
        action: {
            result: FaqModel[];
        },
    ) => {
        draft.faqs = action.result;
        draft.isLoading = false;
    },
});
